const log = {
    invalid_type: 'ประเภทบันทึกไม่ถูกต้อง',
    invalid_time_window: '`end_time` ต้องอยู่หลัง `start_time`',
};
export default Object.freeze(log);
